import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import useLanguageChange from "../../hooks/useLanguageChange";
import { GLOBAL_MEETING_DATA } from "../../constants/PublicVariables";
import { setIsParticipantDrawerOpen } from "../../reducers/common-reducer";
import { CALL_BODY_SCREEN } from "../../constants/Constants";

const ParticipantsListButton = () => {
    const dispatch = useDispatch();
    const localisedValues = useLanguageChange();
    const { isParticipantDrawerOpen, partiCountForDisplay, currentCallBodyScreen } = useSelector((state) => state.commonReducer);

    const handleParticipantModalOpen = () => {
        dispatch(setIsParticipantDrawerOpen(!isParticipantDrawerOpen));
    };

    return (
        <>
            {GLOBAL_MEETING_DATA.isAgent && (
                <div className='action-button participant-action-button'>
                    <div className='action-button-in'>
                        <button
                            className={clsx("call-action-btn open-sidebar-button", isParticipantDrawerOpen && "active")}
                            disabled={currentCallBodyScreen === CALL_BODY_SCREEN.NOTIFY_SCREEN}
                            onClick={() => handleParticipantModalOpen()}
                        >
                            <span className='action-button-icon'>
                                <span className='for-icon icon-multiple-user'></span>
                                <span className='count'>
                                    <span className='count-in'>{partiCountForDisplay}</span>
                                </span>
                            </span>
                            <span className='for-text'>{localisedValues?.participants_title}</span>
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default ParticipantsListButton;
